import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '@/services/api';

const TRACKING_COOLDOWN_MS = 30 * 60 * 1000;

function shouldSkipTracking(pathname) {
  return pathname.startsWith('/admin');
}

function normalizePath(pathname) {
  if (!pathname) return '/';
  if (pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export default function PageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath = normalizePath(pathname);
    if (shouldSkipTracking(normalizedPath)) {
      return undefined;
    }

    const storageKey = `jobfit-page-view:${normalizedPath}`;
    const now = Date.now();
    const lastTrackedAt = Number(window.sessionStorage.getItem(storageKey) || 0);

    if (lastTrackedAt && now - lastTrackedAt < TRACKING_COOLDOWN_MS) {
      return undefined;
    }

    window.sessionStorage.setItem(storageKey, String(now));

    let cancelled = false;

    api.trackPageView(normalizedPath).catch((error) => {
      if (!cancelled) {
        console.error('Failed to track page view:', error);
        window.sessionStorage.removeItem(storageKey);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return null;
}
